export default __webpack_public_path__ + "static/media/velux.7b8f7c1d.png";